<div class="verification-main-container">
  <div class="icon-container">
    <image-loader-utils url="mail" extraClasses="main-svg"></image-loader-utils>
  </div>
  <div class="verification-up-row">
    <div class="up-row-left">{{ 'EMail_Adresse_verifizieren' | translate }}</div>
  </div>

  <div class="sub-text-wrapper">
    <div class="verification-sub-text">
      {{ 'verification_dialog_text' | translate }}
    </div>
  </div>
  <div class="confirm-button-wrapper">
    <div class="confirm-button" (click)="closeDialog()">{{ 'GOT_IT' | translate }}</div>
  </div>
</div>
